module.exports = __webpack_public_path__ + "img/mirakl_logo.9c16eeec.png";